import React from "react";
// import history from "../../../utils/history";
import { useLocation } from "react-router-dom";
import FeedList from "../FeedList";

const MyFeedList = () => {
const location = useLocation();
  const searchURL = location.pathname.split("/");
  const searchParams = searchURL?.[searchURL.length - 1];

  return (
    <div className="max-container">
      <div className="feed-container">
        <FeedList myPosts={searchParams} />
      </div>
    </div>
  );
};

export default MyFeedList;
